import React from 'react';
import { useTranslation } from 'react-i18next';
import { Routes, Route, Navigate } from 'react-router-dom';
import PointageAlertsPage from './PointageAlertsPage';
import DailyTimeTrackingPage from './DailyTimeTrackingPage';
import WeeklyTimeTrackingPage from './WeeklyTimeTrackingPage';
import MonthlyTimeTrackingPage from './MonthlyTimeTrackingPage';
import TimeTrackingCodesPage from './TimeTrackingCodesPage';
import AbsencesPage from './AbsencesPage';
import OvertimePage from './OvertimePage';
import LatenessPage from './LatenessPage';
import TeamPlanningPage from './TeamPlanningPage';
import TimeTrackingConfigPage from './TimeTrackingConfigPage';
import PointageAnalysesRapportsPage from './PointageAnalysesRapportsPage';
import AttendanceDashboardPage from './AttendanceDashboardPage';

const TimeTrackingMainPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.pointage.pages.timeTrackingMainPage.${key}`, opts);

  return (
    <div className="flex-1 p-6 overflow-auto" aria-label={p('title')}>
      <span className="sr-only">{p('subtitle')}</span>
      <Routes>
        <Route path="/" element={<Navigate to="/timetracking/dashboard" replace />} />
        <Route path="/dashboard" element={<AttendanceDashboardPage />} />
        <Route path="/alertes" element={<PointageAlertsPage />} />
        <Route path="/daily" element={<DailyTimeTrackingPage />} />
        <Route path="/weekly" element={<WeeklyTimeTrackingPage />} />
        <Route path="/monthly" element={<MonthlyTimeTrackingPage />} />
        <Route path="/codes" element={<TimeTrackingCodesPage />} />
        <Route path="/stats" element={<Navigate to="/timetracking/daily" replace />} />
        <Route path="/absences" element={<AbsencesPage />} />
        <Route path="/overtime" element={<OvertimePage />} />
        <Route path="/lateness" element={<LatenessPage />} />
        <Route path="/team-planning" element={<TeamPlanningPage />} />
        <Route path="/config" element={<TimeTrackingConfigPage />} />
        <Route path="/analyses-rapports" element={<PointageAnalysesRapportsPage />} />
      </Routes>
    </div>
  );
};

export default TimeTrackingMainPage;

